import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=5cf46d1b&scoped=true"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"
import style0 from "./Edit.vue?vue&type=style&index=0&id=5cf46d1b&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf46d1b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cf46d1b')) {
      api.createRecord('5cf46d1b', component.options)
    } else {
      api.reload('5cf46d1b', component.options)
    }
    module.hot.accept("./Edit.vue?vue&type=template&id=5cf46d1b&scoped=true", function () {
      api.rerender('5cf46d1b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Sector/Post/Edit.vue"
export default component.exports